export interface AlertGroup {
  gid: string
  deviceId: string
  deviceLocation: string
  priorityTier: number | null
  status: AlertStatus
  startAlertTime: string
  endAlertTime: string
  startAlertTimeUTC: string
  endAlertTimeUTC: string
  alertCloseDate?: string | null
  alerts: Alert[]
  hourlyAlertsSentDate?: string | null
  dlId: number
  dUuid: string
  ackBy?: string | null
  // Sum of the estimates actually present. Restricted responses omit estimatedLeak
  // entirely, in which case this is 0 — meaning "no estimates available", not "no leak".
  estimatedLeakTotal: number
  deviceUom?: string
}

export interface Alert {
  id: number
  time: string
  utcTime: string
  createdAt: string
  priorityTier: number | null
  alertScore?: number | null
  status: AlertStatus
  triggerType?: string | null
  actioned?: boolean | null
  ackBy?: string | null
  estimatedLeak?: number | null
  valid: boolean
  excludeUsage?: boolean
  gid: string
  hourlyAlertsSent?: HourlyAlertSent | null
}

interface HourlyAlertSent {
  actionType: number
  sentAt: string
  userIdRef: number
}

export interface HistoricalAlertTier {
  gid: string
  closedDate: string
  startDate: string
  endDate: string
}

// What the historical table's tier buttons hand to the modal: one closed group plus the
// device details needed to render and request it. Built identically at three call sites
// in HistorialAlertView, and previously passed around as `any`.
export interface HistoricalGroupSelection {
  deviceId: string
  dlId: number
  dUuid: string
  deviceUom: string
  timezone: string
  deviceLocation: string
  priorityTier: number
  group: HistoricalAlertTier
}

export interface HistoricalAlert {
  deviceId: string
  dlId: number
  dUuid: string
  tier1: HistoricalAlertTier[]
  tier2: HistoricalAlertTier[]
  tier3: HistoricalAlertTier[]
  tier1Total: number
  tier2Total: number
  tier3Total: number
  total: number
}

export enum AlertStatus {
  OPEN,
  IN_PROGRESS,
  CLOSED,
}

export interface AlertStat {
  ackResult: number
  alertCount: number
}

export interface AlertStats {
  [key: string]: AlertStat[]
}

export interface AlertQuery {
  startDate?: string | null
  endDate?: string | null
  ackResult: number[]
}

export interface Stats {
  tier1Total: number
  tier2Total: number
  tier3Total: number
  totalAll: number
}

export interface StatsDevices extends Stats {
  devices: {
    deviceId: string
    deviceName: string
    tier1: number
    tier2: number
    tier3: number
    total: number
  }[]
}

export interface AlertAPI {
  createdAt: string
  updatedAt?: string | null
  id: number
  ackDate: string | null
  ackResult: number | null
  closedDate: string | null
  deviceId: string
  dlId: number
  dUuid: string
  deviceLocation: string
  deviceName: string
  status: string
  hourlyAlertsSent?: {
    createdAt?: string | null
    updatedAt?: string | null
    id: number
    userIdRef: number
    alertIdRef: number
    deviceIdRef: number
    templateId: string
    mailContent: Record<string, unknown>
    sentAt: string
    actionType: number
  } | null
  hourlyAlertsSentDate?: string | null
  valid: boolean
  gid: string
  utcTime: string
  alertTime: string
  ackBy?: string | null
  actioned?: boolean | null
  alertSent?: boolean | null
  alertScore?: number | null
  triggerType?: string | null
  estimatedLeak?: number | null
}


export interface HistoricalAlertGroupApi {
  ackResult: number
  alertCount: number
  groups: {
    gid: string
    closedDate: string
    startDate: string
    endDate: string
  }[]
}

export interface HistoricalAlertsApi {
  dUuid: string
  dlId: number
  deviceId: string
  alerts: HistoricalAlertGroupApi[]
  total: number
}
